import React from 'react';
import ProfileDropdown from "../parts/ProfileDropdown";
import LogoutButton from "../parts/LogoutButton";

const TopBarModules = () => {
    return (
        <div className='d-flex align-items-center'>
            <ProfileDropdown />
            <LogoutButton />
        </div>
    );
};

export default TopBarModules;
